// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1EjtL","containerItemsCenter":"Skeleton_containerItemsCenter__35Lug"};